export default {
  title: 'Route Management',

  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Route Code, Chinese Name, English Name',
    routeType: 'Route Type',
    routeTypePlaceholder: 'Select Route Type',
    status: 'Status',
    statusPlaceholder: 'Select Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  actions: {
    addRoute: 'Add Route',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    recordsCount: 'Total {count} records',
    enable: 'Enable',
    disable: 'Disable',
    associatePort: 'Associate Port'
  },

  table: {
    routeCode: 'Route Code',
    routeNameCn: 'Route Name (Chinese)',
    routeNameEn: 'Route Name (English)',
    routeType: 'Route Type',
    status: 'Status',
    operation: 'Operation'
  },

  statusText: {
    enabled: 'Enabled',
    disabled: 'Disabled'
  },

  routeType: {
    sea: 'Sea Route',
    air: 'Air Route'
  },

  confirm: {
    toggleStatus: 'Are you sure to {action} this route?'
  },

  modal: {
    title: 'Add Route',
    confirmText: 'Confirm Add',
    searchPlaceholder: 'Search route code, name',
    selected: 'Selected {count} routes',
    filterTip: '💡 Tip: Use keyword and route type filters to find the route data you need'
  },

  messages: {
    loadError: 'Failed to load route data',
    searchError: 'Failed to search routes',
    selectToAdd: 'Please select routes to add',
    associateSuccess: 'Route association successful',
    associateError: 'Route association failed',
    statusToggleSuccess: 'Status toggle successful',
    statusToggleError: 'Status toggle failed',
    selectToEnable: 'Please select routes to enable',
    batchEnableSuccess: 'Batch enable successful',
    batchEnableError: 'Batch enable failed',
    selectToDisable: 'Please select routes to disable',
    batchDisableSuccess: 'Batch disable successful',
    batchDisableError: 'Batch disable failed'
  },

  detail: {
    title: 'Route Port Binding Configuration',
    saveButton: 'Save Configuration',
    basicInfo: 'Route Basic Information',
    routeDescription: 'Route Description',
    routeDescriptionPlaceholder: 'Please enter route description (max 100 characters)',
    portBinding: 'Port Binding Configuration',
    polBinding: 'Port of Loading Binding',
    podBinding: 'Port of Discharge Binding',
    selectPolPlaceholder: 'Please select port of loading',
    selectPodPlaceholder: 'Please select port of discharge',
    addPort: 'Add Port',
    noPortSelected: 'No port selected',
    searchPortPlaceholder: 'Search port name or code',
    enterSearchKeyword: 'Please enter search keyword',
    noSearchResult: 'No matching port found',
    portAlreadyAdded: 'Port already added',
    saveSuccess: 'Save successful',
    saveError: 'Save failed'
  }
}
